<template>
  <div id="app">
    <webform></webform>
  </div>
</template>

<script>
import Webform from "./components/Webform.vue";

export default {
  name: "App",
  components: {
    webform: Webform,
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", Helvetica, "Hiragino Sans GB", Arial,
    sans-serif;
}

* {
  box-sizing: border-box;
}
</style>
